import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTheme, fonts } from "@/theme";
import { useToast } from "@/lib/toast";
import { apiRequest } from "@/lib/api";
import { AuthShell, Field, AuthButton } from "@/pages/auth/AuthShell";

export default function ForgotPassword() {
  const { colors } = useTheme();
  const toast = useToast();
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const requestCode = async (e) => {
    e.preventDefault();
    if (!email) return toast.show("Enter your email first.");
    setLoading(true);
    try {
      await apiRequest("/auth/password-reset/request", { method: "POST", body: { email: email.trim().toLowerCase() } });
      toast.show("If that email exists, a reset code is on its way.");
      setStep(2);
    } catch (err) {
      toast.show(err.message);
    } finally {
      setLoading(false);
    }
  };

  const complete = async (e) => {
    e.preventDefault();
    if (!code || password.length < 8) return toast.show("Enter the code and a new password (8+ chars).");
    setLoading(true);
    try {
      await apiRequest("/auth/password-reset/complete", {
        method: "POST",
        body: { email: email.trim().toLowerCase(), code: code.trim(), new_password: password },
      });
      toast.show("Password updated — sign in with your new one 🖤");
      navigate("/login", { replace: true });
    } catch (err) {
      toast.show(err.message);
    } finally {
      setLoading(false);
    }
  };

  const linkStyle = { color: colors.brandSecondary, fontFamily: fonts.text, fontWeight: 700, textDecoration: "none" };

  return (
    <AuthShell>
      <h2 style={{ color: colors.onSurface, fontSize: 22, fontFamily: fonts.display, fontWeight: 700, margin: "0 0 4px" }}>Reset your password</h2>
      <p style={{ color: colors.muted, fontSize: 14, fontFamily: fonts.text, margin: "0 0 20px" }}>
        {step === 1 ? "We'll send a reset code to your email." : "Enter the code we sent and choose a new password."}
      </p>
      {step === 1 ? (
        <form onSubmit={requestCode}>
          <Field label="Email" testId="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" />
          <AuthButton loading={loading} data-testid="forgot-request">Send reset code</AuthButton>
        </form>
      ) : (
        <form onSubmit={complete}>
          <Field label="Reset code" testId="forgot-code" value={code} onChange={(e) => setCode(e.target.value)} placeholder="6-digit code" />
          <Field label="New password" testId="forgot-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="At least 8 characters" />
          <AuthButton loading={loading} data-testid="forgot-complete">Update password</AuthButton>
          <button type="button" onClick={() => setStep(1)} style={{ background: "none", border: "none", color: colors.muted, fontFamily: fonts.text, fontSize: 13, marginTop: 14, cursor: "pointer", width: "100%" }}>
            ← Use a different email
          </button>
        </form>
      )}
      <p style={{ color: colors.muted, fontSize: 14, textAlign: "center", marginTop: 20, fontFamily: fonts.text }}>
        <Link to="/login" style={linkStyle}>Back to sign in</Link>
      </p>
    </AuthShell>
  );
}
